import React from 'react';
import ConfirmationModal from '../../../../components/modal/confirmationModal';

const RestoreConfirmModal = ({ restoreModal, handleCloseRestoreModal, handleRestore }) => {
  const handleBack = () => {
    handleCloseRestoreModal();
  };
  return (
    <ConfirmationModal
      bodyText="You are about to Restore the Original Transcript and all the changes made by the vendor and by you will be
              lost. You want to continue?"
      open={restoreModal}
      onClose={handleCloseRestoreModal}
      onBack={handleBack}
      onConfirm={handleRestore}
    />
  );
};

export default RestoreConfirmModal;
